import DeveloperToolkitView from 'views/Product/DeveloperToolkitPage'

const DeveloperToolkit = () => <DeveloperToolkitView />

export default DeveloperToolkit
